import type { TRemoteConfigVariantData } from 'helpers/getRemoteConfigVariantData'
import { getAbTestOverridesFromSearch } from 'helpers/getAbTestOverrides'
import { getFilteredCohortAbTestKeys } from 'helpers/getFilteredCohortAbTestKeys'
import { mergeAbTestVariantData } from 'helpers/mergeAbTestVariantData'
import { type Cohort } from 'root-constants'

export const getAbTestVariantData = ({
  firebaseRemoteConfigVariantData,
  growthbookVariantData,
  cohort,
  country,
  search = window.location.search,
}: {
  firebaseRemoteConfigVariantData: TRemoteConfigVariantData | null
  growthbookVariantData: TRemoteConfigVariantData | null
  cohort: Cohort | string
  country?: string
  search?: string
}): TRemoteConfigVariantData => {
  const allowedKeys = getFilteredCohortAbTestKeys(cohort, country)

  return {
    ...mergeAbTestVariantData(
      firebaseRemoteConfigVariantData,
      growthbookVariantData,
    ),
    ...getAbTestOverridesFromSearch(search, allowedKeys),
  }
}
